// /src/pages/private/profile/Profile.jsx

import React from "react";
import { Outlet } from "react-router-dom";

export default function Profile() {
  return <Outlet />;
}
